/*
 * @Author: Dzy
 * @Date: 2022-07-15 15:51:44
 * @LastEditors: Dzy
 * @LastEditTime: 2022-10-13 15:39:52
 * @Description: 用户信息存储
 */
import { defineStore } from 'pinia'

export const useAuthStore = defineStore('authBusi', {
  state: () => {
    return {
      allAccounts: [], // 当前账户所有角色信息
      uinfo: {} // 该账户所有信息
    }
  },
  actions: {
    update_allAccounts(data) {
      this.allAccounts = data
    },
    update_uinfo(data) {
      this.uinfo = data
    }
  },
  // 所有数据持久化 插件其他配置
  persist: true
})
